<template>
  <div>
    <h1 class="text-3xl mb-4">Domaines</h1>

    <table class="mb-4 w-full">
      <thead>
        <tr>
          <td class="py-3 px-2 font-semibold text-center">id</td>
          <td class="py-3 px-2 font-semibold text-center">domain</td>
          <td class="py-3 px-2 font-semibold text-center">PayingDomain</td>
          <td class="py-3 px-2 font-semibold text-center">EditableEC</td>
          <td class="py-3 px-2 font-semibold">banner</td>
          <td class="py-3 px-2 font-semibold text-center">color</td>
          <td class="py-3 px-2 font-semibold" width="1%"></td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(domain, index) of domains" :key="index" :class="{ 'bg-gray-100': !(index % 2) }">
          <td class="py-2 px-2 text-center">
            {{ domain.id }}
          </td>

          <td class="py-2 px-2 font-mono text-center">
            {{ domain.hostname }}
          </td>

          <td
            :class="{'py-2 px-2 font-mono text-center text-green-500' : domain.paying_domain, 'py-2 px-2 font-mono text-center text-red-500' : !domain.paying_domain }">
            {{ domain.paying_domain }}
          </td>

          <td
            :class="{ 'py-2 px-2 font-mono text-center text-green-500': domain.editable_ec, 'py-2 px-2 font-mono text-center text-red-500': !domain.editable_ec }">
            {{ domain.editable_ec }}
          </td>

          <td class="py-2 px-2 break-all">
            <a :href=domain.banner>Voir</a>
          </td>

          <td class="py-2 px-2">
            <span class="text-white p-1 rounded font-semibold text-xs" :style="`background-color: ${domain.color}`">
              {{ domain.color }}
            </span>
          </td>

          <td class="py-2 px-2">
            <router-link :to="`/domaines/${domain.id}/modifier`"
              class="bg-blue-500 text-white px-2 py-1 rounded shadow">
              modifier
            </router-link>
          </td>

          <td class="py-2 px-2">
            <button @click="deleteDomain(domain.id)" class="bg-red-500 text-white px-2 rounded shadow">
              supprimer
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <router-link to="/domaines/nouveau"
      class="bg-blue-500 hover:bg-blue-600 px-4 py-2 rounded text-white shadow float-right" tag="button">
      Nouveau domaine
    </router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {
      domains: []
    }
  },

  async mounted() {
    const { data } = await this.$axios.get('/domains')

    this.domains = data
  },

  methods: {
    async deleteDomain(domainId) {
      if (confirm('Supprimer le domaine ?')) {
        try {
          await this.$axios.delete(`/domains/${domainId}`)

          this.domains.splice(this.domains.findIndex(d => d.id === domainId), 1)
        } catch (err) {
          alert('Une erreur c\'est produite')
        }
      }
    }
  }
}
</script>
